import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@mui/material';

import { calcRem } from 'utils';
import { NONE } from 'constants/dinerSignupConstants';

// TODO: add close popup logic https://getbentobox.atlassian.net/browse/DMD-2832
const AlertButton = ({ buttonProps, handleClick = null }) => {
  if (buttonProps.action === NONE) {
    return null;
  }
  return (
    <Button
      sx={{
        borderRadius: 0,
        marginBottom: calcRem(16)
      }}
      disableElevation
      href={buttonProps.url}
      variant="contained"
      onClick={handleClick} // if handleClick is null this property will not be passed
    >
      {buttonProps.label}
    </Button>
  );
};

AlertButton.propTypes = {
  buttonProps: PropTypes.shape({
    action: PropTypes.string,
    label: PropTypes.string,
    url: PropTypes.string
  }).isRequired,
  handleClick: PropTypes.func.isRequired
};

export default AlertButton;
